// extracted by mini-css-extract-plugin
export default {"Button":"Foau9zEUF_pBL14fovyP","Variant--opened":"Wtuk2wkKGhXT3xjaMAal"};